<template>
    <div id="user-details" class="root">
        <div class="row">
            <div class="col-lg-12 content-title mt-1 mb-3">
                <div class="col-lg-12 content-title mt-1 mb-3">
                    <h2 class="content-title">Felhasználói adatok {{user.id ? '#'+user.id : ''}}</h2>
                </div>
            </div>
        </div>
        <loader :loading="loading_status"></loader>
        <div class="row">
            <div class="col-lg-12 content-body" v-if="!loading_status">
                <div class="user-info">
                    <div class="row form-group">
                        <div class="col-sm-3">
                            <label class="control-label">Vezetéknév</label>
                            <input type="text" class="form-control" v-model="user.first_name" autocomplete="off"
                                   :class="{ 'field-error' : this.$v.user.first_name.$error }"/>
                        </div>
                        <div class="col-sm-3">
                            <label class="control-label">Keresztnév</label>
                            <input type="text" class="form-control" v-model="user.last_name" autocomplete="off"
                                   :class="{ 'field-error' : this.$v.user.last_name.$error }"/>
                        </div>
                        <div class="col-sm-3">
                            <label class="control-label text-danger">E-mail</label>
                            <input type="text" class="form-control" v-model="user.email" autocomplete="off"
                                   :class="{ 'field-error' : this.$v.user.email.$error }"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-3">
                            <label class="control-label">Jelszó</label>
                            <input type="password" class="form-control" v-model="user.password" autocomplete="off"
                                   :class="{ 'field-error' : this.$v.user.password.$error }"/>
                        </div>
                        <div class="col-sm-3">
                            <label class="control-label">Jelszó</label>
                            <input type="password" class="form-control" v-model="user.confirm_password" autocomplete="off"
                                   :class="{ 'field-error' : this.$v.user.confirm_password.$error }"/>
                        </div>
                    </div>
                    <div class="row form-check">
                        <div class="col-sm-8">
                            <div class="row">
                                <div class="col-sm-6">
                                    <input type="checkbox" class="form-check-input" v-model="user.is_admin"/>
                                    <label class="form-check-label">Adminisztrátor</label>
                                </div>
                                <div class="col-sm-6 d-none">
                                    <input type="checkbox" class="form-check-input" v-model="user.is_active" v-bind:value="user.is_active"/>
                                    <label class="form-check-label">Aktiv</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="action-buttons pt-4">
                    <div class="row form-group">
                        <div class="col-lg-3 text-center mx-auto">
                            <div class="row">
                                <div class="col">
                                    <button class="btn btn-md btn-primary" @click="save">Mentés</button>
                                </div>
                                <div class="col" v-if="user.id">
                                    <button class="btn btn-md btn-primary btn-danger" @click="confirmDelete">Törlés</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import required from "vuelidate/src/validators/required";
    import requiredIf from "vuelidate/src/validators/requiredIf";
    import Loader from '../common/controls/Loader'

    export default{
        name: 'user-details',
        data(){
            return{
            }
        },
        components: {
            Loader
        },
        computed: {
            ...mapGetters([
                'userDetails',
                'loading',
                'userID',
            ]),
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            user: {
                get:function() {
                    return this.userDetails;
                },
                set:function(newVal) {
                    return newVal;
                }
            },
        },
        methods: {
            ...mapActions([
                'addUser',
                'updateUser',
                'deleteUser',
                'setUserDetails',
            ]),
            getUser() {
                if(parseInt(this.$route.params.id) > 0) {
                    this.$store.dispatch('getUser', {
                        id: this.$route.params.id
                    }).then((response) => {
                        if(response === null || ( !response.is_active )) {
                            this.$store.commit('setErrorMessage', '#'+this.$route.params.id+' felhasználó nem létezik!');

                            this.$router.push({
                                name: 'users',
                            });
                        }
                    });
                } else {
                    this.user = this.userDetails;
                }
            },
            setUserDetails(data) {
                this.$store.commit('setUserDetails', data);
            },
            save() {
                this.$v.user.$touch();

                if(!this.$v.user.$invalid) {

                    if(this.user.password !== this.user.confirm_password) {
                        this.$store.commit('setErrorMessage', 'A két jelszó nem egyezik!');
                        return;
                    }

                    this.user.created_by = this.userID;
                    this.user.updated_by = this.userID;

                    if (this.user.id) {
                        this.updateUser(this.user).then((response) => {
                            if(response.id > 0) {
                                this.$router.push({
                                    path: '/users/' + response.id,
                                });
                            }
                        });
                    } else {
                        this.addUser(this.user).then((response) => {
                            if(response.id > 0) {
                                this.$router.push({
                                    path: '/users/' + response.id,
                                });
                            }
                        });;
                    }

                } else {
                    this.$store.commit('setErrorMessage', 'Töltse ki a megjelölt mezőket!');
                }
            },
            confirmDelete() {
                let vm = this;
                this.$dialog.confirm('Tényleg szeretné törölni a #'+this.user.first_name+ ' '+this.user.last_name+' felhasználót?', {})
                    .then((dialog) => {
                        vm.deleteUser({
                            id: vm.user.id,
                        }).then((response) => {
                            this.$router.push({
                                name: 'users',
                            });
                            dialog.close();
                        });
                    });
            },
            clientNav(id) {
                window.location.href= '/users/'+id;
            },
        },
        mounted() {
            this.setUserDetails({});
            this.getUser();
        },
        watch: {
            userData: {
                handler:  function(newVal) {
                    this.user = newVal;
                },
                deep: true,
            },
        },
        validations() {
            let vm = this;

            return {
                user: {
                    first_name: {
                        required,
                    },
                    last_name: {
                        required,
                    },
                    email: {
                        required,
                    },
                    password: {
                        required: requiredIf(function () {
                            return !vm.user.id || vm.user.id <= 0;
                        }),
                    },
                    confirm_password: {
                        required: requiredIf(function () {
                            return vm.user.password;
                        }),
                    },
                }
            }
        },
    }
</script>

<style scoped="" lang="scss">
    button{
        padding-bottom: 7px;
    }
    .action-buttons input[type=checkbox]{
        position: relative;
        top: 1px;
        right: 3px;
    }
    .modules {
        a {
            color: #3d5170;
        }

        a:hover{
            text-decoration: none;
            color: #007bff;
        }

        ul{
            list-style: none;
            li {

            }
        }
        label {
            input {
                margin-right: 5px;
            }
        }
    }
</style>